import { createQueryKeys } from "@lukemorales/query-key-factory";
import { get } from "@/api/api";
import { useSuspenseQuery } from "@tanstack/react-query";

export const metricNames = createQueryKeys('metric-names', {
  detail: (
    metricName: string,
  ) => ({
    queryKey: [metricName],
    queryFn: async () => {
      return await get<{ name: string, unit: string }>(`metric-names/${metricName}/`);
    },
  }),
  all: () => ({
    queryKey: ["all"],
    queryFn: async () => {
      return await get<string[]>(`metric-names/`);
    },
  }),
});

export const useMetricNames = () => {
  return useSuspenseQuery(metricNames.all())
}
